import { Listing } from "../types";
import nhsdDirectorySearch, { Pagination } from "./nhsdDirectorySearch";

type ParamKeys =
  | "latitude"
  | "longitude"
  | "name"
  | "postcode"
  | "offset"
  | "language";
type ProviderDirectorySearchParams = Partial<Record<ParamKeys, string>>;

export type ProviderDirectorySearchArgs = {
  params: ProviderDirectorySearchParams;
  searchService?: (
    params: ProviderDirectorySearchParams
  ) => Promise<[Array<Listing>, Pagination | null]>;
};

const providerDirectorySearch = async ({
  params,
  searchService = nhsdDirectorySearch,
}: ProviderDirectorySearchArgs) => {
  return await searchService(params);
};

export default providerDirectorySearch;
